export const DD = {
  bg: "#0a0a0a",
  surface: "rgba(255,255,255,0.025)",
  surfaceSolid: "#111111",
  border: "rgba(255,255,255,0.06)",
  borderSolid: "#1a1a1a",
  text: "#f1f5f9",
  textSecondary: "rgba(255,255,255,0.5)",
  textTertiary: "rgba(255,255,255,0.22)",
  accent: "#f97316",
  accentHover: "#ea580c",
  accentBg: "rgba(249,115,22,0.10)",
  accentBorder: "rgba(249,115,22,0.25)",
  indigo: "#6366f1",
  warning: "#f59e0b",
  danger: "#ef4444",
  purple: "#8b5cf6",
  green: "#22c55e",
  blue: "#3b82f6",
};

export const POST_TYPES = [
  { value: "update", icon: "📢", label: "Standard", color: DD.green },
  { value: "offer", icon: "🏷️", label: "Offer", color: DD.accent },
  { value: "event", icon: "📅", label: "Event", color: DD.blue },
];

export const CTA_TYPES = [
  { value: "none", label: "No button" },
  { value: "LEARN_MORE", label: "Learn More" },
  { value: "BOOK", label: "Book" },
  { value: "ORDER", label: "Order Online" },
  { value: "SHOP", label: "Shop" },
  { value: "SIGN_UP", label: "Sign Up" },
  { value: "CALL", label: "Call Now" },
  { value: "GET_OFFER", label: "Get Offer" },
];

export const TONE_OPTIONS = [
  { value: "professional", label: "Professional" },
  { value: "friendly", label: "Friendly & Casual" },
  { value: "authoritative", label: "Authoritative" },
  { value: "witty", label: "Witty & Fun" },
  { value: "informative", label: "Informative" },
  { value: "urgent", label: "Urgent & Action-Driven" },
];

export const STATUS_CONFIG: Record<string, { label: string; color: string; bg: string; icon: string }> = {
  draft: { label: "Draft", color: "#64748b", bg: "rgba(100,116,139,0.12)", icon: "✎" },
  review: { label: "In Review", color: "#f59e0b", bg: "rgba(245,158,11,0.10)", icon: "👁" },
  approved: { label: "Approved", color: DD.green, bg: "rgba(34,197,94,0.10)", icon: "✓" },
  scheduled: { label: "Scheduled", color: DD.indigo, bg: "rgba(99,102,241,0.10)", icon: "◉" },
  published: { label: "Published", color: "#22c55e", bg: "rgba(34,197,94,0.10)", icon: "●" },
};

export const STATUS_PILLS: Record<string, { label: string; color: string; bg: string }> = {
  ready: { label: "Ready to Publish", color: DD.green, bg: "rgba(34,197,94,0.10)" },
  needs_image: { label: "Needs Image", color: DD.warning, bg: "rgba(245,158,11,0.10)" },
  review: { label: "Review", color: DD.warning, bg: "rgba(245,158,11,0.10)" },
  scheduled: { label: "Scheduled", color: DD.indigo, bg: "rgba(99,102,241,0.10)" },
  published: { label: "Published", color: DD.green, bg: "rgba(34,197,94,0.10)" },
};

export const BRAND_VOICES = [
  { value: "professional", label: "Professional" },
  { value: "conversational", label: "Conversational" },
  { value: "authority", label: "Authority" },
  { value: "local-expert", label: "Local Expert" },
];

export const DAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
export const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
